import { JSX } from 'react';
import { TKey } from '~/src/dash/publicaUI';

export interface ISimpleOption {
  customComponent?: JSX.Element;
  icon?: string;
  isDisabled?: boolean;
  key: string;
  label: string;
  value: string;
  tKey?: TKey;
}

export interface ISimpleOptionSelect extends ISimpleOption {
  isSelected: boolean;
  backgroundColor?: string;
  color?: string;
}

// helper to get options
export const getSimpleSingleOptionSelects = (
  items: Array<ISimpleOption>,
  selectedValue: string,
  isOptionDisabled: (opt: ISimpleOption) => boolean = () => false,
): Array<ISimpleOptionSelect> => {
  return items.map((item) => ({
    ...item,
    isSelected: item.value === selectedValue,
    isDisabled: isOptionDisabled(item),
  }));
};

export const getSimpleDropdownOptionSelects = (
  items: Array<ISimpleOption>,
  selectedValues: string[],
): Array<ISimpleOptionSelect> => {
  return items.map((item) => ({
    ...item,
    isSelected: selectedValues.includes(item.value),
  }));
};
